import { useEffect, useState } from "react";

// True on phone-width screens (Tailwind's `sm` breakpoint is 640px, so this is everything below it).
//
// The wide reports freeze their identity columns to the left. On a desktop that keeps Date /
// Session / Menu Item in view while the measures scroll; on a phone those columns are 342-398px of
// a ~360-412px viewport, so the frozen block fills the screen and the data columns cannot be
// reached at all. Screens use this to drop the freeze below `sm` and let the table scroll normally.
export const useIsMobile = (query = "(max-width: 639px)") => {
    const get = () => (typeof window !== "undefined" && window.matchMedia
        ? window.matchMedia(query).matches
        : false);

    const [isMobile, setIsMobile] = useState(get);

    useEffect(() => {
        if (typeof window === "undefined" || !window.matchMedia) return;
        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);
        // addEventListener is the current API; addListener is kept for older Safari/Android WebViews,
        // which this runs on.
        if (mql.addEventListener) mql.addEventListener("change", onChange);
        else mql.addListener(onChange);
        setIsMobile(mql.matches);
        return () => {
            if (mql.removeEventListener) mql.removeEventListener("change", onChange);
            else mql.removeListener(onChange);
        };
    }, [query]);

    return isMobile;
};

export default useIsMobile;
